
import React from 'react'
import icon from './svgs/showGray.svg'
import { BaseIcon } from './_base'

export const ShowGrayIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon={icon} {...{fontSize,size,...sx}} />
    )
}
